export class VoidDto {

  constructor(init?: Partial<VoidDto>) {
    Object.assign(this, init);
  }
}
